
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3823|4853|7731|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
